/* eslint-disable react-hooks/rules-of-hooks */
// Disabling lint in this file as the hooks rule doesn't apply
import React from 'react';
import { useSelector } from 'react-redux';
import { SmartLink } from 'Components/SmartLink';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { scrollByElementClientHeight } from 'Utils/Utils';
import { ImageContent } from 'Components/FreeFormPanels/Shared/ImageContent';
import { isDefaultPlanFlow } from 'Utils/Analytics/Amplitude';
import './Hero.css';

const useHeroAnalytics = {
  trackHeroSlideUp: () => {
    trackEvent(TRACKING_ENUMS.EVENT_HERO_BUTTON_CLICK, {
      page_item_title: 'down arrow',
      page_action_location: 'hero',
    });
  },
  trackUpgradeClick: (ctaText) => {
    trackEvent(TRACKING_ENUMS.EVENT_UPGRADE_CLICKED, {
      page_item_title: ctaText,
      page_action_location: 'hero',
    });
    trackEvent(TRACKING_ENUMS.EVENT_PURCHASE_CTA_CLICKED, {
      page_button_text: ctaText,
      page_action_location: 'hero',
      page_item_title: 'join fox nation',
    });
  },
};

export const Hero = ({ source }) => {
  if (!source[0]) {
    return null;
  }

  const { headline, description, image, ctaText } = source[0];
  const { trackHeroSlideUp, trackUpgradeClick } = useHeroAnalytics;
  const { routes } = useSelector((s) => s.appConfig);
  const heroItem = React.createRef();
  const linkUrl = isDefaultPlanFlow() ? routes.signupCreateAccount : routes.signupPlans;

  const onDownArrowClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    scrollByElementClientHeight(heroItem && heroItem.current);
    trackHeroSlideUp();
  };

  return (
    <div className="statelessHero">
      <ImageContent image={image} type="png" />
      <div className="content" ref={heroItem}>
        <div className="headersGroup">
          {headline && <div className="headline">{headline}</div>}
          {description && <div className="description">{description}</div>}
          {ctaText && (
            <SmartLink
              text={ctaText}
              linkUrl={linkUrl}
              className="ctaLink"
              reload
              onClick={() => trackUpgradeClick(ctaText)}
            />
          )}
        </div>
        <div className="heroDownArrowWrapper">
          <span
            className="heroDownArrow"
            role="button"
            onClick={onDownArrowClick}
            aria-label="Down Arrow"
            onKeyDown={onDownArrowClick}
          />
        </div>
      </div>
    </div>
  );
};
